import TypeIt from "typeit";

export const typeit = () => {

    const elements = document.querySelectorAll('.masthead.is-full-height .masthead--copy__p');

    elements.forEach(element => {

        new TypeIt(element, {
            speed: 50,
            afterComplete: function (instance) {
                instance.destroy(true);
              },
        }).go();

    });

    const elements2 = document.querySelectorAll('.masthead.is-minimum-height .masthead--title');

    elements2.forEach(element => {

        new TypeIt(element, {
            speed: 50,
            afterComplete: function (instance) {
                instance.destroy(true);
              },
        }).go();

    });

};